import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSetDisplaySegmentationChosen = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback((id: string) => dispatch({ type: 'DISPLAY_SEGMENTATION_CHOSEN', payload: { id } }), [dispatch]);
};
